import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function PrivacyPolicyPage() {
  return (
    <div style={{ 
      position: 'relative', 
      zIndex: 1, 
      paddingTop: '100px',
      paddingBottom: '80px',
      minHeight: '100vh',
      background: '#0a1628',
    }}>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '0 24px' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: 'var(--vvs-muted)',
            textDecoration: 'none',
            fontSize: '11px',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontFamily: 'Space Grotesk',
            marginBottom: '40px',
            transition: 'color 0.3s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#F0F4F8'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--vvs-muted)'}
        >
          <ChevronLeft size={14} /> Home
        </Link>

        <h1 style={{
          fontFamily: 'Syne, sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 48px)',
          textTransform: 'uppercase',
          color: '#F0F4F8',
          marginBottom: '16px',
          letterSpacing: '-0.02em',
        }}>
          Privacy Policy
        </h1>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '12px', 
          color: 'var(--vvs-muted)', 
          marginBottom: '48px',
          letterSpacing: '0.1em',
        }}>
          Last updated: February 2026
        </p>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '14px', 
          color: 'var(--vvs-muted)', 
          lineHeight: 1.9,
          marginBottom: '40px',
        }}>
          Vague Vision Sound ASBL ("VVS") is committed to protecting your personal data in accordance with the General Data Protection Regulation (GDPR) and applicable Belgian law.
        </p>

        <div style={{ color: '#F0F4F8', fontFamily: 'Space Grotesk, sans-serif', fontSize: '14px', lineHeight: 1.9 }}>
          <Section number="1" title="Who We Are">
            <p>Vague Vision Sound ASBL</p>
            <p>Rue du Trône 214/7, 1050 Ixelles, Brussels, Belgium</p>
            <p>Enterprise number: BE1019412986</p>
            <p>contact@vaguevisionsound.com</p>
          </Section>

          <Section number="2" title="What Data We Collect">
            <List items={[
              'Name and email address (contact form, ticket purchase)',
              'Payment data (processed exclusively by third-party ticketing platforms // VVS does not store payment information)',
              'Usage data (anonymous analytics if applicable)',
            ]} />
          </Section>

          <Section number="3" title="Legal Basis for Processing">
            <List items={[
              'Contractual necessity: processing your ticket purchase or event registration',
              'Legitimate interest: responding to contact form submissions',
              'Consent: sending event-related communications (where you have opted in)',
            ]} />
          </Section>

          <Section number="4" title="Processors & Third Parties">
            <p style={{ marginBottom: '12px' }}>Your data may be shared with:</p>
            <List items={[
              'Third-party ticketing platforms (for ticket purchases)',
              'Email service providers (for communications)',
              'Website hosting provider (Emergent)',
            ]} />
            <p style={{ color: 'var(--vvs-muted)', marginTop: '16px' }}>
              We do not sell your data to third parties. Some of our service providers may be located outside the EEA. Where this is the case, appropriate safeguards are in place in accordance with GDPR requirements.
            </p>
          </Section>

          <Section number="5" title="Data Retention">
            <p style={{ color: 'var(--vvs-muted)' }}>
              Personal data is retained only as long as necessary for the purpose for which it was collected, and no longer than required by applicable law.
            </p>
          </Section>

          <Section number="6" title="Your Rights">
            <p style={{ marginBottom: '12px' }}>Under GDPR, you have the right to:</p>
            <List items={[
              'Access your personal data',
              'Request correction or deletion',
              'Restrict or object to processing',
              'Data portability (where applicable)',
              'Withdraw consent at any time',
              'Lodge a complaint with the Belgian Data Protection Authority (APD): https://www.dataprotectionauthority.be',
            ]} />
            <p style={{ color: 'var(--vvs-muted)', marginTop: '16px' }}>
              To exercise any of these rights: contact@vaguevisionsound.com
            </p>
          </Section>

          <Section number="7" title="Cookies">
            <p style={{ color: 'var(--vvs-muted)' }}>
              This website may use essential cookies for basic functionality. No advertising or tracking cookies are used without your prior consent.
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ number, title, children }) {
  return (
    <div style={{ marginBottom: '40px' }}>
      <h2 style={{
        fontFamily: 'Syne, sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        textTransform: 'uppercase',
        color: 'var(--vvs-cyan)',
        marginBottom: '16px',
        letterSpacing: '0.08em',
      }}>
        {number}. {title}
      </h2>
      {children}
    </div>
  );
}

function List({ items }) {
  return (
    <ul style={{ margin: 0, paddingLeft: '20px' }}>
      {items.map((item, i) => (
        <li key={i} style={{ color: 'var(--vvs-muted)', marginBottom: '8px' }}>{item}</li>
      ))}
    </ul>
  );
}
